<!--
 * @Author: 759729757@qq.com 759729757@qq.com
 * @Date: 2022-11-17 22:19:16
 * @LastEditors: 759729757@qq.com 759729757@qq.com
 * @LastEditTime: 2022-12-30 10:22:27
 * @FilePath: \meishu_web\src\pages\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="">
    
      <div class="search-bar">
        <ul class="search-type">
          <!-- <li class="active">全部</li>
          <li>文学</li>
          <li>哲学</li>
          <li>文化</li>
          <li>科技</li> -->
        </ul>
        <!-- <svg t="1671377161359" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2687" width="32" height="32"><path d="M789.804097 737.772047 742.865042 784.699846 898.765741 940.600545 945.704796 893.672746Z" p-id="2688" fill="#616161"></path><path d="M456.92259 82.893942c-209.311143 0-379.582131 170.282245-379.582131 379.582131s170.270988 379.570875 379.582131 379.570875c209.287607 0 379.558595-170.270988 379.558595-379.570875S666.210197 82.893942 456.92259 82.893942zM770.128989 462.477097c0 172.721807-140.508127 313.229934-313.206398 313.229934-172.720783 0-313.229934-140.508127-313.229934-313.229934s140.508127-313.229934 313.229934-313.229934C629.620861 149.247162 770.128989 289.75529 770.128989 462.477097z" p-id="2689" fill="#616161"></path></svg> -->
        <input class="search-input" v-model="keywords" @change="searchData" type="text" placeholder="搜索图书">
      </div>

      <div class="book-warp">

        <template v-for="(item, index) in books" >
          
        <!-- 图书 -->
          <div class="book-item" v-if="item.poster" :key="index">
              <img class="book-poster" src="./assets/book2.jpg" alt="">
              <div class="book-info">
                  <div class="book-title">
                      {{item.name}}
                      <span class="book-sub-title">
                          {{item.publisher}}
                            <br>
                          <!-- ISBN：9787115434500 -->
                      </span>
                  </div>
                  <div>
                      <span class="pull-right position">
                          {{item.location}}
                      </span>
                  </div>
              </div>
          </div>
          <!-- 文字形式 -->
          <div class="book-item-row" v-else :key="index">
            <div class="book-title">
               {{item.name}}
            </div>
            <div class="book-detail">
              <div>
                {{item.publisher}} / {{item.author}}
              </div>
              <div>
                {{item.location}}
              </div>
            </div>
          </div>
        </template>

      </div>
      
       <el-pagination class="pull-right"
        @current-change="getData"
        :page-size="10"
        background
        :current-page.sync="currentPage"
        layout=" pager, next, jumper"
        next-text="下一页"
        :total="count">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import {selectBooksAsPage, countBooks} from "./api/index";
export default {
  data(){
    return {
      keywords: '',  
      books: [],
      count: 0,
      currentPage: 1
    }
  },   
  methods: {
    searchData: function(){
      this.currentPage = 1;
      this.getData();
    },
    getData: async function(){
      var data = await selectBooksAsPage(this.keywords, this.currentPage - 1);
      var count = await countBooks(this.keywords);
      this.books = data.data;
      this.count = count.data;
    }
  },
  mounted(){
    this.getData();
  }

}
</script>

<style>
.pull-right{
  float: right;
}
.book-warp{
    display: flex;
    flex-wrap: wrap;
}
.book-item{
    display: flex;
    width: 400px;
    justify-content: space-between;
    align-items: stretch;
    box-shadow: 6px 6px 9px rgba(0, 0, 0, .06);
    margin-right: 40px;
    margin-bottom: 35px;
}
.book-poster{
    width: 160px;
}
.book-info{
    /* width: 250px; */
    flex: 1;
    padding: 10px 30px 20px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.book-title{
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    color: #616161;
}
.book-sub-title{
    display: inline-block;
    margin-top: 10px;
    line-height: 24px;
    color: #909090;
    font-size: 14px;
}
.book-sub-info{
    display: inline-block;
    margin-top: 10px;
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;

}
.position{
    font-size: 20px;
    color: #616161;
    font-weight: bold;
}
.search-bar{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "思源黑体 CN";
}
.search-type{
  list-style: none;
  display: flex;
  color: #616161;
  font-size: 16px;
  font-weight: bold;
  padding-left: 0;
}
.search-type li{
  margin-right: 30px;
}
.search-type li.active{
  color: #EE6532;
}
.search-input{
  background-color: #F2F0F0;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAD4ElEQVRYR8WXXWgcVRTH/2d2N/qQ1AdBRaQ10ir1wdoqfoCESAWtLaLg+mBMuPduElBRKypIX1yfAmIRE0FNsvfMBkRwkQqt2IeKBQu2WAyKhSp+LFQSH0TRdMGV7By5y2xJpzsz2U1I52Vg7vn43XPOPfcM4TI/dJn9oyOA4eHha3K53D1BENxARFeJyKLneQtLS0vHK5XKf91sZlUAWutxAHsBPBLj5F8AHwGoMPORTkASAYwxIyLyPIA7IkZ/A/A7gNsBZCNrh4noDWvtidWAxAIopV4jomLLiIgUPc+bF5F5Zj7nvheLxWy1Wt1JRLtE5EkiGgjl6yLykO/7x9Mg2gIopfJE5ELqnlNE9KK19qs0Y0qpCSJ6tSWXy+Wun56eXkzSuwRgpXMietxa+3Ga4+i61vprAHcCOMzMcXXTVLsIQCl1HRF9CWArgElmfqFT505+ZGTk6kwm80eoe4CZJ+LsRAEmieg5EfmrVqttrlQq57sBcDrGmP0i8haA841GY2Bubm6+na2LALTWrrjcGX/aWvtet86d3uDgYLa/v/8UgF0AJpj5QCLA2NjYzcvLyz84Ic/ztpVKpZ/WAuB0tdbvA3A95Cwzb08E0Frvc0UD4Bwzb16r8zANLp2TzWIj2mStXYravZCCsNs54s+Y+eH1ANBa3w3gpLOVzWZvmZmZ+TEWoNV4XMPxff/19QAI0yDuLSL3t2tMFyJgjCmIyCwRfWKtfWw9AAqFws4gCL5xtoIg2Foul39OSsGDAI4CqDJz/3oAtDblbPX29l45NTVVjwUYHR29ttFouAsGmUzmptnZ2V/XCqGUeoeIniWio9baPal9QCn1LRHdBuAVZn5zLQDGmL4gCE6E9p5h5ndTAYwxL4lI07GIbPd9/2y3EMaYOREZBnDG87yBUqn0ZypAeHaPichuEfnO9/0d3QAUCoXdQRAcC8//U9baD+LsXHIbGmPuExGnfAWAt5l5fycQSqltRNQ870RUsdY+kaQfNw8MEtEXoeL3RKSttafTQFZcQE1RZk4d+WIFtNa3AvgUwI1hTRSJ6IyInPZ9v+q+jY+P5+r1+l1EtIOIXO94ILpzY8whAAfjRrREQgfhxjIRyUd2v+BmQlfhIhKdCQ8y88tOXil1iIgeBfA3Ee1rB5EaorCdaiLaIyL3uuu6TSpcZE6KyIflcvnz1no+n8/09fUdcfNhHMSqAFY6HBoa2tTT09P8LwiCYLFWqy0k/RNEIP4hor0rI9ExQFohtluPQLgeM+D7vhv9Ovsz6sZ5m3RsCevhlw0FcM7CSGyx1jadbzhAuwhuSA0kpe5/5I2gMFKCtpMAAAAASUVORK5CYII=);
  background-repeat: no-repeat;
  background-position: 10px center;
  background-size: 24px;
  padding-left: 50px;
  height: 30px;
  border: none;
  border-radius: 20px;
  color: #616161;
  font-weight: bold;
}
.book-item-row{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 35px;
}
.book-item-row .book-title{
  width: 50%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABI0lEQVRIS9XVv0rEQBDH8d+kt/R9fArr7COI2qhcc9x5hT6AQmaHLYJod4WVoNjYCGpjY2GjpahlimQkwUAQEjf/EFMv3w+7yWwIIz80ch9/B4RhuJZl2adz7q7PLmt3YIx5BrAKYN9aO+uKNAFaid4Q0YKZl20hX6DsHqVpuuuce/OF2gJ59wXA1Fp77IN0AcruOYBta+1jE9QHKLpENGHmaR3SG/gOPxDRBjNf/oSGAoquqhoRkSoyNLAuImdjALdBEGxGUXQ9+BER0RYzH47xkk9VdU9Engb9TFU1v6N2RORkjEE7SJJkHsfxu0+8mJO6hcaY6mV3RUQzZr7wDZfrmoBXACuqOheRRdvwr0D+wwHwISL3XeONR9Qn6jVo/wb4AtDYfBmTEHOTAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 24px;
  padding-left: 30px;
}
.book-item-row .book-detail{
  color: #616161;
  font-size: 18px;
  font-weight: bold;
  line-height: 30px;
  text-align: right;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  border-radius: 100%;
  background-color: white;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #6790C7;
}

</style>


// WEBPACK FOOTER //
// src/App.vue